export const HANDOFF_MESSAGES = {
    unavailable: 'Signing in through this page is not available in this environment.',
    incorrectCredentials: 'Incorrect email or password.',
    unsupportedAccount: "This account can't sign in here yet.",
    accountNotFound: "We couldn't find an account for this email that can sign in to this application.",
    signInFailed: 'Sign-in failed. Please try again.',
    completeFailed: "We couldn't complete sign-in to the application. Please try again.",
};
